import { type AnyAction } from 'redux';
import { type ThunkDispatch } from 'redux-thunk';

export const updateLastCompanyAndClearParcelIds =
  (company: any) => (dispatch: ThunkDispatch<unknown, unknown, AnyAction>) => {
    dispatch({
      type: 'UPDATE_LAST_COMPANY',
      payload: company,
    });

    dispatch({
      type: 'CLEAR_PARCEL_IDS',
    });
  };
